module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "clearfix c-header"
  }, [_c('div', {
    staticClass: "contain"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require('./assets/logo.png'),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tabbar"
  }, [_c('router-link', {
    attrs: {
      "to": "/medianav/web"
    }
  }, [_vm._v("\n            网站联盟中心\n          ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/medianav/mobile"
    }
  }, [_vm._v("\n            移动联盟中心\n          ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://tiyan.adyun.com",
      "target": "_blank"
    }
  }, [_vm._v("\n            推广体验中心\n          ")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://ssp.adyun.com/Passport/register",
      "target": "_blank"
    }
  }, [_vm._v("\n            媒介合作\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "clearBoth"
  })], 1)])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('footer-nav')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4a07c112!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 444
// module chunks = 2